export type ConversationStatus = "disconnected" | "connecting" | "connected";

export type ConversationMode =
  | "idle"
  | "speaking"
  | "listening"
  | "thinking" // Brief pause after user stops (< 1s)
  | "processing" // Medium duration (1-3s)
  | "searching" // Longer duration (3-5s)
  | "retrieving"; // Very long duration (5s+)

export interface StatusMessageVariants {
  connecting: string[];
  disconnected: string[];
  speaking: string[];
  listening: string[];
  thinking: string[];
  processing: string[];
  searching: string[];
  retrieving: string[];
  ready: string[];
}

export const DEFAULT_STATUS_MESSAGES: StatusMessageVariants = {
  connecting: ["Connecting...", "Setting things up...", "Getting ready..."],
  disconnected: ["Click to start"],
  speaking: [
    "Speaking...",
    "Illuminating...",
    "Synthesizing insights...",
    "Orchestrating thoughts...",
    "Crystallizing knowledge...",
    "Weaving narratives...",
    "Articulating patterns...",
    "Composing response...",
    "Manifesting ideas...",
    "Transmuting concepts...",
  ],
  listening: [
    "Listening...",
    "Absorbing context...",
    "Ingesting your input...",
    "Parsing nuances...",
    "Calibrating understanding...",
    "Deciphering intent...",
    "Resonating with possibilities...",
    "Encoding meaning...",
    "Harmonizing signals...",
    "Mapping dimensions...",
    "Crystallizing intent...",
    "Weaving threads...",
  ],
  thinking: [
    "Thinking...",
    "Cogitating...",
    "Harmonizing patterns...",
    "Percolating ideas...",
    "Traversing possibilities...",
    "Calibrating response...",
    "Converging on insight...",
    "Distilling essence...",
    "Sculpting perspective...",
    "Mapping topology...",
    "Integrating signals...",
  ],
  processing: ["Processing that...", "Working on it...", "Give me a sec..."],
  searching: ["Searching my knowledge...", "Looking that up...", "Let me find that..."],
  retrieving: ["Gathering information...", "Almost there...", "Still working on it..."],
  ready: ["Ready for your question", "How can I help?", "I'm here to help"],
};
